import React from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import Page from '@constants/page';
import ElectricalActionSummaryDetails from "./ActionSummaryDetails/electrical/ElectricalActionSummaryDetails";
import LiftingActionSummaryDetails from './ActionSummaryDetails/lifting/LiftingActionSummaryDetails';
import styles from './UploadFileListPage/UploadListPage.module.scss';
import UploadListPage from './UploadListPage/UploadListPage';
import UploadFileListPage from './UploadFileListPage/UploadFileListPage';
import ReportDetails from './ReportDetails/ReportDetails';
import ForbiddenPage from './ForbiddenPage/ForbiddenPage';

function PageContent() {
  return (
    <div className={styles.content}>
      <BrowserRouter>
        <Routes>
          <Route path={Page.HOME.path} element={<UploadListPage />} />
          <Route path={Page.FILE_LIST.path} element={<UploadFileListPage />} />
          <Route path={Page.LIFTING_ACTION_SUMMARY.path} element={<LiftingActionSummaryDetails />} />
          <Route path={Page.ELECTRICAL_ACTION_SUMMARY.path} element={<ElectricalActionSummaryDetails />} />
          <Route path={Page.REPORT_DETAILS.path} element={<ReportDetails />} />
          <Route path={Page.FORBIDDEN.path} element={<ForbiddenPage />} />
          <Route
            path="*"
            element={
              <main style={{ padding: '1rem' }}>
                <p>There is nothing here!</p>
              </main>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default PageContent;
